import React, { useCallback } from 'react';
import './style.scoped.css';
import { Reason } from 'src/models/Reason';

interface ReasonItemSelectorProps {
  data: Reason[];
  onSelect?: (reasonID: any) => void;
}

const ReasonItemSelector = ({
  data,
  onSelect,
}: ReasonItemSelectorProps) => {
  const _handleClick = useCallback((item: Reason) => {
    if (item.disabled) return;
    onSelect(item.reasonID);
  }, [onSelect]);

  const _renderItem = useCallback((item: Reason, index: number) => {
    return (
      <div
        onClick={() => _handleClick(item)}
        key={item.reasonID}
      >
        <div className={'text-center item_list mb-4 ' + (item.checked ? 'bg-primary' : 'bg-white')}>
          {item.text}
        </div>
      </div>
    );
  }, [_handleClick]);

  return <div className="reason">{data.map(_renderItem)}</div>;
};

export default ReasonItemSelector;
